// Use the mean to classify the rate map into 10 steps
export class StandardRateLogic {
    constructor(monoChrome = false) {
        this.monoChrome = monoChrome
    }

    getColors(monoChrome) {
        if (monoChrome) {
            return [
                'rgb(209,209,255)',
                'rgb(190,190,255)',
                'rgb(171,171,255)',
                'rgb(152,152,255)',
                'rgb(133,133,255)',
                'rgb(114,114,255)',
                'rgb(95,95,255)',
                'rgb(76,76,255)',
                'rgb(57,57,255)',
                'rgb(38,38,255)',
                'rgb(0,0,255)',
            ]
        }

        return [
            '#800000',
            '#ff0000',
            '#ee6800',
            '#fbac00',
            '#fff300',
            '#a1ce00',
            '#5eb500',
            '#009b0e',
            '#005400',
            '#0a5191',
            '#04005c',
        ]
    }

    getSteps(data, rateProperty) {
        let filteredData
        let mean = 0
        if (data.features[0]) {
            const nonZeroFeatures = data.features.filter(
                (f) => f.properties[rateProperty] !== 0,
            )
            let nonZeroData = nonZeroFeatures
                .map((f) => f.properties[rateProperty])
                .sort((a, b) => a - b)
            if (nonZeroData.length === 0) {
                nonZeroData = [0]
            }
            const q1 = nonZeroData[Math.floor(nonZeroData.length / 4)]
            const q3 = nonZeroData[Math.floor(nonZeroData.length * (3 / 4))]
            const irq = q3 - q1
            const lowerBound = q1 - (1.5 * irq)
            const upperBound = q3 + (1.5 * irq)

            filteredData = nonZeroData.filter((d) => d >= lowerBound && d <= upperBound)
            mean = filteredData.reduce((a, b) => a + b, 0) / filteredData.length
        }
        const step = mean / 10

        const makeSteps = (tmean, tstep) => {
            if (tstep <= 0.2) {
                return [-0.00000011, -0.000001, -0.0000009, -0.0000008, -0.0000007, -0.0000006, -0.0000005, -0.0000004, -0.0000003, -0.0000002, 0]
            }

            // Boundary offsets (in units of tstep) from the mean, strictly decreasing.
            const offsets = [3.5, 2.5, 1.5, 0.5, -0.5, -1.5, -2.5, -3.5, -4.5]
            const boundarySteps = []
            offsets.forEach((offset) => {
                let rounded = Math.round(tmean + (offset * tstep))
                // Rounding can make two adjacent boundaries collapse to the same
                // integer when tstep < 1; force strictly decreasing values instead.
                if (boundarySteps.length > 0 && rounded >= boundarySteps[boundarySteps.length - 1]) {
                    rounded = boundarySteps[boundarySteps.length - 1] - 1
                }
                boundarySteps.push(rounded)
            })

            return [...boundarySteps, 0.00001, 0]
        }

        const steps = makeSteps(mean, step).reverse()

        return steps
    }
}
